import React from 'react'
import { useCachedBackgroundImage } from '@renderer/hooks/useCachedBackgroundImage'
import { BK_ASSET, BK_CANVAS } from './layout'

interface BkScreenProps {
  /** Filename inside /assets/bingkai-kenangan, e.g. `welcome.webp`. */
  plate: string
  children?: React.ReactNode
  /** Extra classes on the canvas root, e.g. `touch-none` for a gesture page. */
  className?: string
}

/**
 * The frame every BK page sits in: one full-bleed 1920x1080 plate, with
 * absolutely-positioned children on top in design pixels.
 */
const BkScreen: React.FC<BkScreenProps> = ({ plate, children, className = '' }) => {
  const background = useCachedBackgroundImage(BK_ASSET(plate))

  return (
    <div
      className={`relative overflow-hidden bg-cover bg-center ${className}`}
      style={{
        width: BK_CANVAS.width,
        height: BK_CANVAS.height,
        backgroundImage: background ? `url(${background})` : undefined
      }}
    >
      {children}
    </div>
  )
}

export default BkScreen
